module.exports = __webpack_public_path__ + "public/files/img/banner.a93333cc.png";